module.exports = __webpack_public_path__ + "static/media/nossa-missao.335b00dd.m4v";